import { render, staticRenderFns } from "./onboarding_form.vue?vue&type=template&id=2c1bbdd1"
import script from "./onboarding_form.vue?vue&type=script&lang=js"
export * from "./onboarding_form.vue?vue&type=script&lang=js"
import style0 from "./onboarding_form.vue?vue&type=style&index=0&id=2c1bbdd1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports